import { render, staticRenderFns } from "./SectionItemRanking.vue?vue&type=template&id=2faba7fb&lang=pug&"
import script from "./SectionItemRanking.vue?vue&type=script&lang=js&"
export * from "./SectionItemRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports